import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import imgMain from "../../assets/img-main-1.webp";
import Footer from "../../components/footer/Footer";
import Search from "../../components/search/Search";
import logoHeader from "../../assets/logo-header.svg";
import icone1 from "../../assets/icone-1.png";
import icone2 from "../../assets/icone-2.png";
import icone3 from "../../assets/icone-3.png";
import icone4 from "../../assets/icone-4.png";
import mapaPontilhado from "../../assets/mapa-pontilhado.svg";
import cadastreSuaMala from "../../assets/cadastre-sua-mala.jpeg";
import recebaPedidosDeEnvio from "../../assets/receba-pedidos-de-envio.jpeg";
import entregueAEncomenda from "../../assets/entregue-a-encomenda.jpeg";
import recebaSuaGrana from "../../assets/receba-sua-grana.jpeg";
import {
  saveToGlobalState,
  removeSpecificData,
} from "../../utils/localStorage";
import { useAuth } from "../../context/AuthContext";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function App() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(window.innerWidth <= 980);

  const { setShowLoginModal, user } = useAuth();

  useEffect(() => {
    document.body.classList.add("home-page");

    return () => {
      document.body.classList.remove("home-page");
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth <= 980);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePrevent = (e) => {
    if (e?.currentTarget?.getAttribute("href") === "#") {
      e.preventDefault();
    }
  };

  const handleStorage = () => {
    removeSpecificData("qual_meio_transporte");

    if (user?.serie) {
      saveToGlobalState({
        voltando_trajeto: "nao",
      });
      navigate("/qual-meio-transporte");
    } else {
      saveToGlobalState({
        voltando_trajeto: "nao",
        tab_login: "MALA",
      });
      setShowLoginModal(true);
    }
  };

  const slides = [
    {
      num: "01",
      img: cadastreSuaMala,
      title: "Cadastre sua mala",
      text: "Cadastre-se e ofereça o espaço que tiver em suas viagens para levar encomendas e faturar uma grana extra.",
    },
    {
      num: "02",
      img: recebaPedidosDeEnvio,
      title: "Receba pedidos de envio",
      text: "Será notificado sempre que alguém manifestar o interesse no envio de encomenda por seu intermédio.",
    },
    {
      num: "03",
      img: entregueAEncomenda,
      title: "Entregue a encomenda",
      text: "Quando encontrar com o viajante entregue a encomenda para a pessoa indicada para concluir a missão",
    },
    {
      num: "04",
      img: recebaSuaGrana,
      title: "Receba sua grana",
      text: "Transforme sua mala em uma fonte de renda.",
    },
  ];

  return (
    <>
      <style>{`
        :root {
          --blue: #1576e9;
          --cyan: #19c7c8;
          --teal: #11b9a3;
          --green: #15b36b;
          --dark: #111318;
          --muted: #5e6677;
          --soft: #f5f8fb;
          --card: #ffffff;
          --line: #dbe8f4;
          --shadow: 0 18px 50px rgba(17, 24, 39, 0.08);
          --radius: 22px;
          --radius-sm: 16px;

          /* Largura fixa por faixa */
          --page-width: 948px;

          /* Tamanhos por faixa */
          --hero-title-size: 52px;
          --app-title-size: 34px;
          --section-title-size: 28px;
          --hero-text-size: 17px;
          --app-text-size: 17px;
        }

        * {
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          margin: 0;
          color: var(--dark);
          background: #fff;
          overflow-x: hidden;
        }

        .page {
          margin: none !important;
        }
        
        .hero {
        padding: 24px 0 18px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 24px;
        align-items: center;
        position: relative;
        }

        .hero-copy {
          padding: 20px 0 10px;
        }

        .hero h1 {
          margin: 0;
          font-size: var(--hero-title-size);
          line-height: 1.1;
          letter-spacing: -0.05em;
          max-width: 15ch;
          font-weight: 700;
        }

        .hero p {
          margin: 18px 0 22px;
          max-width: 380px;
          color: #6a7384;
          font-size: var(--hero-text-size);
          line-height: 1.35;
        }

        .cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: 270px;
          padding: 10px 30px;
          border: none;
          border-radius: 999px;
          color: white;
          text-decoration: none;
          font-weight: 700;
          font-size: 18px;
          background: linear-gradient(
            90deg,
            #1a7fe7 0%,
            #19c4c9
          );
          box-shadow: 0 16px 30px rgba(21, 118, 233, 0.12);
          cursor: pointer;
          transition: transform 0.2s ease;
        }

        .cta:hover {
          transform: translateY(-1px);
          background: #0ed079ff 100%
        }

        .hero-visual {
        position: relative;
        min-height: 430px;
        display: flex;
        align-items: center;
        margin-right: calc(-40vw + 50%);
        }
        

        .circle-photo {
        width: 100%;
        height: 100%;
        border-radius: 46% 0 0 46%;
        position: relative;
        }

        .circle-photo img {
          width: 110%;
          height: 100%;
          object-fit: cover;
          object-position: center right; 
          display: block;
          margin-top: -50px;
          margin-left: -120px;
          filter: saturate(1.02);
        }

        .circle-photo::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.02),
            rgba(255, 255, 255, 0) 30%
          );
          pointer-events: none;
        }

        

        .icon-bubble{
          width: 100px;
          margin-top: -18px;
          margin-left: -25px
        }

        .features {
          margin-top: 50px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 0;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: var(--shadow);
        }

        .feature {
          padding: 22px 22px 24px;
          color: #fff;
          min-height: 138px;
        }

        .feature:nth-child(1) {
          background: linear-gradient(135deg, #156fe0, #0d7de8);
        }

        .feature:nth-child(2) {
          background: linear-gradient(135deg, #10aad6, #18c7be);
        }

        .feature:nth-child(3) {
          background: linear-gradient(135deg, #11b48a, #13b35f);
        }

        .feature h2 {
          margin: 0 0 8px;
          font-size: 23px;
          line-height: 1.05;
          letter-spacing: -0.03em;
        }

        .feature p {
          margin: 0;
          font-size: 16px;
          line-height: 1.5;
          opacity: 0.95;
        }
 
        .band {
          margin: 16px 0 28px;
          background: linear-gradient(
            90deg,
            #1a7fe7 0%,
            #19c4c9 40%         
          );
          color: #fff;
          text-align: center;
          padding: 25px 12px;
          border-radius: 0;
          font-weight: 800;
          letter-spacing: 0.03em;
          font-size: 20px;
        }

        .steps {
          padding: 18px 0 24px;
          position: relative;
        }

        .steps-grid {
          position: relative;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 18px;
          align-items: start;
        }

        .step {
          position: relative;
          min-height: 220px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 10px 10px 0;
        }
 
        .step .bubble {
            width: 90px;
            height: 90px;
            border-radius: 50%;
            border: 15.5px solid transparent;
            background: linear-gradient(#fff, #fff) padding-box, linear-gradient(140deg, var(--blue) 0%, var(--cyan) 70%) border-box;
            display: grid;
            place-items: center;
            font-size: 34px;
            color: #18b7cf;
            margin-top: 42px;
            z-index: 2;
        }

        .step .text {
          position: absolute;
          max-width: 200px;
          font-size: 15px;
          line-height: 1.2;
          color: #171c24;
          font-weight: 800;
          letter-spacing: -0.02em;
        }

        .step small {
          display: block;
          margin-top: 8px;
          font-weight: 300;
          font-size: 14px;
          color: #000;
          line-height: 1.45;
        }

        .step:nth-child(1) .text {
          top: 18px;
          left: 10px;
          text-align: left;
        }

        .step:nth-child(2) .text {
          bottom: 12px;
          left: 50%;
          transform: translateX(-50%);
        }

        .step:nth-child(3) .text {
          top: 18px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
        }

        .step:nth-child(4) .text {
          bottom: 12px;
          right: 10px;
          text-align: left;
        }

       .pricing-wrap {
              margin-top: 20px;
              background: linear-gradient(
            90deg,
            #1a7fe7 0%,
            #19c4c9 40%
          );
              padding: 60px 20px;
              position: relative;
              overflow: hidden;
              min-height: 400px;
              /* Centraliza os cards */
              display: flex; 
              justify-content: center;
              align-items: center;
              gap: 20px;
          }

          .pricing-wrap::before {
              content: "";
              position: absolute;
              inset: 0;
              background-image: var(--bg-image);
              background-position: -200px 550px; 
              background-size: 900px; 
              opacity: 1; 
              z-index: 0;
          }

          .swiper-button-prev,
            .swiper-button-next {
              width: 44px;
              height: 44px;
              border-radius: 50%;
              background: #ffffff99;
              box-shadow: 0 4px 15px rgba(0,0,0,.15);
              color: #1cb5e0;
            }

            .swiper-button-prev::after,
            .swiper-button-next::after {
              font-size: 18px;
              font-weight: bold;
            }

            .swiper-button-prev svg,
            .swiper-button-next svg {
              width: 16px !important;
              height: 16px !important;
            }

          .pricing-wrap > * {
              position: relative;
              z-index: 1;
          }

        .pricing-wrap .swiper {
        width: 100%;
        padding: 20px 0;
        overflow: visible
        
        }

        .pricing-wrap .swiper-slide {
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        }

        .price-card {
        margin: 0;
        box-sizing: border-box;
        }

        .price-card {
        width: 100%;
        max-width: 280px;
        min-width: 0;
        background: #fff;
        border-radius: 16px;
        padding: 18px 22px 14px;
        box-shadow: 0 18px 35px rgba(1, 9, 18, 0.3);
        min-height: 210px;
        display: flex;
        margin: 0 auto;
        overflow: hidden;
        flex-direction: column;
        }

        .price-card h4 {
          margin: 0 0 10px;
          font-size: 18px;
          line-height: 1;
          letter-spacing: -0.02em;
        }

        .title-badge {
          font-size: 24px;
          font-weight: 700;
          color: #333;
          margin-bottom: 20px;
          margin-top: 0;
        }

        .price-badge {
          background: linear-gradient(
                90deg,
                var(--blue) 0%,
                var(--cyan) 95%,
                var(--cyan) 100%
            );
          color: #fff;
          width: 140px;
          padding: 15px;
          border-radius: 12px;
          display: flex; 
          align-items: baseline;
          justify-content: center;
          margin-bottom: 25px;
        }

        .currency-badge {
          font-size: 16px;
          font-weight: bold;
          margin-right: 0px;
        }

        .value-badge {
          font-size: 40px;
          font-weight: 800;
          line-height: 1;
        }

        .cents-badge {
          font-size: 18px;
          align-self: flex-start;
          margin-top: 5px;
        }

        .route-container {
          margin-bottom: 25px;
          position: relative;
          padding-left: 20px;
        }

        .route-container::before {
          content: '';
          position: absolute;
          left: 5px;
          top: 10px;
          bottom: 10px;
          width: 2px;
          border-left: 5px dotted #1cb5e0;
        }

        .location-badge {
          font-size: 13px;
          font-weight: 800;
          color: #444;
          margin: 5px 0;
        }

        .icon-box {
          width: 25px;
          height: 25px;
          border: 3px solid #1cb5e0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 5px 0;
          background: #fff;
          z-index: 1;
          position: relative;
        }


        .footer-badge {                
            background: linear-gradient(
                90deg,
                var(--blue) 0%,
                var(--cyan) 10%,
                var(--cyan) 100%
            );
            color: #fff;
            font-weight: 500;
            padding: 10px 2000px 12px 20px; 
            margin-top: 10px; 
            margin-right: -2000px; 
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: flex-start; 
            gap: 10px;
            width: fit-content;
            white-space: nowrap; 
        }

        .clock-icon-badge {
          position: relative;
          top: 1px;
          left: -12px;
        }

        .duracao-badge{
          position: relative;
          font-size: 13px;
          left: -16px
        }

        .price-card ul {
          list-style: none;
          padding: 0;
          margin: 0;
          color: #374151;
          font-size: 13px;
          line-height: 1.6;
          flex: 1;
        }

        .price-card li {
          margin: 3px 0;
        }

        .mini-btn {
          margin-top: 12px;
          border: none;
          border-radius: 999px;
          background: linear-gradient(90deg, #0d7de8, #18c7be);
          color: #fff;
          font-weight: 800;
          padding: 10px 12px;
          font-size: 13px;
          cursor: pointer;
        }

        .app-section {
          padding: 34px 0 12px;
          display: grid;
          max-width: 400px;
          grid-template-columns: 1.05fr 0.95fr;
          align-items: center;
          justify-content: center;
          gap: 24px;
        }

        .app-copy h2 {
          margin: 0;
          font-size: var(--app-title-size);
          line-height: 1.02;
          letter-spacing: -0.04em;
          max-width: 470px;
          font-weight: 900;
        }

        .app-copy h2 .accent {
          color: #18b7cf;
        }

        .app-copy p {
          margin: 12px 0 18px;
          color: #3f4857;
          font-weight: 600;
          font-size: var(--app-text-size);
        }

        .stores {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
          padding: 10px;
          border-radius: 20px;
          background: linear-gradient(
            90deg,
            #1a7fe7 0%,
            #19c4c9 40%         
          );
        }

        .store {
          display: inline-flex; 
          align-items: center;
          justify-content: center;
          gap: 10px;
          min-width: 164px;
          padding: 11px 16px;
          border-radius: 14px;
          background: #fff;
          border: 2px solid #e3edf7;
          box-shadow: 0 10px 24px rgba(17, 24, 39, 0.04);
          font-weight: 700;
          text-decoration: none;
          color: #202733;
        }

        .store em {
          font-style: normal;
          font-size: 12px;
          color: #667085;
          display: block;
          font-weight: 600;
        }

        .phone-wrap {
          display: flex;
          align-items: center;
          min-height: 300px;
          position: relative;
        }

        .phone .shadow-phone {
              position: absolute;
              bottom: 10px; 
              left: 155px; 
              width: 250px; 
              height: 15px; 
              background: linear-gradient(to right, 
                  rgba(0, 0, 0, 0.4) 0%, 
                  rgba(0, 0, 0, 0.1) 40%, 
                  transparent 90%
              );
              transform: rotateX(30deg) rotateZ(-10deg) skewX(20deg);
              filter: blur(8px); 
              z-index: -1; 
          }

          .phone .shadow-phone-2 {
              position: absolute;
              bottom: -25px; 
              left: 25px; 
              width: 180px; 
              height: 25px; 
              background: linear-gradient(to right, 
                  rgba(0, 0, 0, 0.2) 0%, 
                  rgba(0, 0, 0, 0.4) 10%, 
                  transparent 90%
              );
              transform: rotateX(60deg) rotateZ(0deg) skewX(20deg);
              filter: blur(8px); 
              z-index: -1; 
          }

        .phone {
            width: 170px;
            height: 340px;
            background: #fff;
            border-radius: 36px;
            position: relative;
            margin-top: 30px;
            margin-left: -50px;
            transform: perspective(1200px) rotateY(-32deg) rotateX(14deg) rotateZ(2deg);
            transform-style: preserve-3d;
            border-left: 7px solid #222;
            border-top: 3px solid #222;
            border-right: 5px solid #111;
            border-bottom: 10px solid #111;
            box-shadow: 
                10px -1px 1px #000,         
                inset 0 0 15px rgba(0,0,0,0.05);
            }

            .phone::before {
            content: "";
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 70px;
            height: 18px;
            background: #111;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
            z-index: 10;
            }

            .phone::after {
            content: ""; 
            position: absolute;
            text-align: center;
            color: #1c9dd4;
            font-weight: 800;
            top: 0px; left: 0; width: 100%; height: 100%;
            background-image: var(--bg-image);
            background-position: center;
            background-size: 100px; 
            background-repeat: no-repeat;          
            border-radius: 30px;
            pointer-events: none;
            }

        .section-title {
          margin: 0 auto;
          text-align: center;
          font-size: var(--section-title-size);
          line-height: 1.1;
          letter-spacing: -0.04em;
          font-weight: 900;
          width: 80%;
        }

        .benefits {
          padding-bottom: 28px;
          overflow: hidden;
        }

        .benefit-section{
        width:100%;
        max-width:100vw;
        overflow:hidden;
        padding:60px 0;
        }

        .benefit-section .swiper {
          margin-top: 30px
        }

        .benefit-section .swiper-slide{
        display:flex;
        justify-content:center;
        }

        .benefit-section .swiper-slide{
        opacity:.6;
        transform:scale(.8);
        transition:.4s;
        }

        .benefit-section .swiper-slide-active{
        opacity:1;
        transform:scale(1);
        }

        .benefit-card{
        width:90%;
        height:300px;
        max-width:600px;
        border-radius:24px;
        overflow:hidden;
        position:relative;
        }

        .benefit-card img{
        width:100%;
        height:100%;
        object-fit:cover;
        transition:transform .5s ease;
        }

        .benefit-card:hover img{
        transform:scale(1.08);
        }

      .slide-number {
          position: absolute;
          top: 16px;
          left: 16px;
          z-index: 3;

          width: 52px;
          height: 52px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 50%;
          background: #fff;
          color: #000;
          font-weight: 800;
          font-size: 1.3rem;

          box-shadow: 0 10px 24px rgba(0,0,0,0.25);
        }

        .overlay{
        position:absolute; 
        inset:0;
        background:linear-gradient(
            90deg,
            rgba(0,95,190,.85) 0%,
            rgba(0,95,190,.85) 20%, 
            rgba(0,0,0,.15) 100%
        );
        }

        .txt{
          position:absolute;
          bottom:24px;
          left:24px;
          right:24px;
          color:white;
          z-index:2;
        }

        .txt h3{
          margin-top: -180px;
          width: 200px;
          font-size:22px;
          font-weight:900;
        }

        .txt p{
          margin-top:-10px;
          margin-left:0px;
          width: 200px;
          font-size:14px;
          opacity:.85;
          line-height:1.4;
        }
        
        .svg-lines {
          position: relative;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }

        .path-style {
          fill: none;
          stroke: #19c7c8;
          stroke-width: 4; 
          stroke-linecap: round;
        }

        @media (min-width: 981px) and (max-width: 1199px)  {
          :root {
            --page-width: 948px;
            --hero-title-size: 45px;
            --app-title-size: 34px; 
            --section-title-size: 28px;
            --hero-text-size: 22px;
            --app-text-size: 17px;
          }

          .hero h1{
            width: 400px;
          }

        .subtitle-main{
           width: 340px;
          }

        .feature-step-1{
          width: 240px; 
        }

        .feature-step-2{
          width: 250px; 
        }

        .feature-step-3{
          width: 250px; 
        }

        #how-it-works{
            margin-top: 70px;            
            transform: translateX(-3%)
        }

        .text{
            display: inline-flex
        }

        #svg-find-your-suitcase{
            position: relative;
            left: -28px;
            top: -35px
        }
        #bubble-find-your-suitcase {
            position: relative;
            top: 7px;
            left: -190px;
          }
          #title-find-your-suitcase {
            margin: 175px -295px;
            width: 90px;
            font-size: 20px;
          }
          #desc-find-your-suitcase {
            position: relative;
            width: 220px;
            top: 170px;
            left: 330px;
            text-align: left;            
          }

          #svg-deliver-your-order{
                position: relative;
                top: 100px; 
                left: -300px;
                transform: scaleY(-1) translate(1%, -0.5%)
            }
        #bubble-deliver-your-order {
            position: relative;
            top: 7px;
            left: -460px;
          }
          #title-deliver-your-order {
            position: relative;
            top: 605px;
            left: -585px;
            height: 50px;
            width: 790px;
            font-size: 20px;
            text-align: right;
          }
          #desc-deliver-your-order {
            position: relative;
            width: 800px;
            top: 345px;
            left: -440px;
            margin: 260px -110px;
          }

           #svg-track-your-order{
            position: relative;
            left: 388px;
            top: -273px
          }
          #bubble-track-your-order {
            position: relative;
            top: -230px;
            left: 224px;
          }
          #title-track-your-order {
            position: absolute;
            left: 0px;
            text-align: right;
            margin: -323px 58px;
            width: 250px;
            font-size: 20px;
          }
          #desc-track-your-order {
            position: relative;
            width: 235px;
            top: -330px;
            left: 348px;
            text-align: left;
          }

         #svg-confirm-receipt{
                position: relative;
                top: -136px;
                left: 116px;
            }
            #bubble-confirm-receipt {
            position: relative;
            top: -235px;
            left: -48px;
          }
          #title-confirm-receipt {
            position: relative;
            top: -118px;
            left: -117px;
            height: 50px;
            width: 710px;
            font-size: 20px;
            text-align: right;
          }
          #desc-confirm-receipt {
            position: relative;
            width: 770px;
            top: 0px;
            left: -20px;
            margin: -120px -60px;
            text-align: left;
          }

          #svg-end-line{
            position: relative;
            top: -373px;
            left: 865px;
          }
 
          .pricing-wrap {
            margin-top: -350px;
          }

          .container-title-app-section{
            width: 1200px
          }

        }

        @media (min-width: 1199px) and (max-width: 1439px) {
          :root {
            --page-width: 1120px;
            --hero-title-size: 57px;
            --app-title-size: 40px;
            --section-title-size: 32px;
            --hero-text-size: 22px;
            --app-text-size: 18px;
          }

          .hero h1{
            width: 500px;
          }

        .subtitle-main{
           width: 340px;
          }

        .feature-step-1{
          width: 240px; 
        }

        .feature-step-2{
          width: 250px; 
        }

        .feature-step-3{
          width: 250px; 
        }

          #how-it-works{
            margin-top: 70px;            
            transform: translateX(0%)
            }

            .text{
                display: inline-flex
            }

            .step .bubble{
                width: 100px;
                height: 100px;
            }

            .icon-bubble{
              width: 120px;
              margin-top: -22px;
              margin-left: -22px
            }

        #svg-find-your-suitcase{
            position: relative;
            left: -40px;
            top: -35px 
        }
        #bubble-find-your-suitcase {
            position: relative;
            top: 32px;
            left: -239px;
          }
          #title-find-your-suitcase {
            margin: 180px -335px;
            width: 90px;
            font-size: 20px; 
          }
          #desc-find-your-suitcase {
            position: relative;
            width: 200px;
            top: 175px;
            left: 373px;
            text-align: left;
          }

          #svg-deliver-your-order{
                position: relative;
                top: 125px;
                left: -360px;
                transform: scaleY(-1) translate(1%, -0.5%)
            }
        #bubble-deliver-your-order {
            position: relative;
            top: 32px; 
            left: -556px;
          }
          #title-deliver-your-order {
            position: relative;
            top: 667px;
            left: -617px; 
            height: 50px;
            width: 900px;
            font-size: 20px;
            text-align: right;
          }
          #desc-deliver-your-order {
            position: relative;
            width: 1280px;
            top: 410px;
            left: -520px;
            margin: 260px -60px;
            text-align: left;
          }

           #svg-track-your-order{
            position: relative;
            left: 448px;
            top: -302px
          }
          #bubble-track-your-order {
            position: relative;
            top: -235px;
            left: 248px; 
          }
          #title-track-your-order {
            position: absolute;
            left: 0px;
            text-align: right;
            margin: -350px 87px;
            width: 250px;
            font-size: 20px;
          }
          #desc-track-your-order {
            position: relative;
            width: 190px;
            top: -355px;
            left: 376px;
            text-align: left;
          }

         #svg-confirm-receipt{
                position: relative;
                top: -140px;
                left: 125px;
            }
            #bubble-confirm-receipt {
            position: relative;
            top: -235px;
            left: -73px;
          }
          #title-confirm-receipt {
            position: relative;
            top: -102px;
            left: -134px;
            height: 50px;
            width: 710px;
            font-size: 20px;
            text-align: right;
          }
          #desc-confirm-receipt {
            position: relative;
            width: 940px;
            top: 0px;
            left: -20px;
            margin: -100px -80px;
            text-align: left;
          }

          #svg-end-line{
            position: relative;
            top: -407px;
            left: 1005px;
          }

          .pricing-wrap {
            margin-top: -400px;
          }

          .container-title-app-section{
            width: 1200px
          }
        }

        @media (min-width: 1440px) {
          :root {
            --page-width: 1280px;
            --hero-title-size: 65px;
            --app-title-size: 46px;
            --section-title-size: 36px;
            --hero-text-size: 25px;
            --app-text-size: 18px;
          }

          body {
            bacground: pink
          }

          .hero h1{
            width: 600px;
          }

          .subtitle-main{
           width: 370px;
          }

          .feature-step-1{
            width: 240px; 
          }

          .feature-step-2{
            width: 250px; 
          }

          .feature-step-3{
            width: 250px; 
          }

          #how-it-works{
            margin-top: 70px;            
            transform: translateX(0%)
            }

            .text{
                display: inline-flex
            }

            .step .bubble{
                width: 140px;
                height: 140px;
            }

            .icon-bubble{
              width: 140px;
              margin-top: -15px;
              margin-left: -15px
            }

        #svg-find-your-suitcase{
            position: relative;
            left: -90px;
            top: -35px 
        }
        #bubble-find-your-suitcase {
            position: relative;
            top: 70px;
            left: -305px;
          }
          #title-find-your-suitcase {
            margin: 180px -410px;
            width: 90px;
            font-size: 20px;
          }
          #desc-find-your-suitcase {
            position: relative;
            width: 200px;
            top: 175px;
            left: 450px;
            text-align: left;
          }

          #svg-deliver-your-order{
                position: relative;
                top: 150px;
                left: -430px;
                transform: scaleY(-1) translate(1%, -0.5%)
            }
        #bubble-deliver-your-order {
            position: relative;
            top: 68px;
            left: -643px;
          }
          #title-deliver-your-order {
            position: relative;
            top: 715px;
            left: -825px;
            height: 50px;
            width: 620px;
            font-size: 20px;
            text-align: right;
          }
          #desc-deliver-your-order {
            position: relative;
            width: 535px;
            top: 455px;
            left: -675px;
            margin: 260px -105px;
            text-align: left;
          }

           #svg-track-your-order{
            position: relative;
            left: 510px;
            top: -340px;
          }
          #bubble-track-your-order {
            position: relative;
            top: -232px;
            left: 295px;
          }
          #title-track-your-order {
            position: absolute;
            left: 0px;
            text-align: right;
            margin: -377px 120px;
            width: 250px;
            font-size: 20px;
          }
          #desc-track-your-order {
            position: relative;
            width: 190px;
            top: -385px;
            left: 416px;
            text-align: left;
          }

         #svg-confirm-receipt{
                position: relative;
                top: -153px;
                left: 170px;
            }
            #bubble-confirm-receipt {
            position: relative;
            top: -237px;
            left: -45px;
          }
          #title-confirm-receipt {
            position: relative;
            top: -92px;
            left: -135px;
            height: 50px;
            width: 710px;
            font-size: 20px;
            text-align: right;
          }
          #desc-confirm-receipt {
            position: relative;
            width: 960px;
            top: 0px;
            left: 10px;
            margin: -92px -100px;
            text-align: left;
          }

          #svg-end-line{
            position: relative;
            top: -461px;
            left: 1200px;
          }

          .pricing-wrap {
            margin-top: -440px
          }

          .container-title-app-section{
            width: 1200px
          }

          .app-section { 
            position: relative;
            max-width: 900px;
            left: 100px
          }

          .app-copy h2{
            max-width: 550px
          }

        }

        @media (max-width: 980px) {
          .hero,
          .app-section, 
          .footer-grid {
            grid-template-columns: 1fr;
          }

          .hero {
            display: inline
          }

          .hero h1 {
            max-width: none
          }

          .hero-copy {
            position: relative;
            left: 50%;
            width: 90%;
            transform: translateX(-50%);
          }

          .hero-visual {
            order: -1;
            min-height: 340px;
            width: 100%;
            justify-content: center;
          }

          .circle-photo {
            border-radius: 32px;
            aspect-ratio: 1.2/0.9;
            display:none;
            width: 100%;
          }

          .circle-photo img {
           margin-left: -50px
          }

          .container-search-bar{
            margin-top: -330px;
          }

          .step {
            min-height: 180px;
          }

          .step .text {
            position: static;
            transform: none !important;
            max-width: none;
            margin-bottom: 12px;
          }

          .step .bubble {
            margin-top: 0;
          }

          #how-it-works{
            display: block
            }

          #svg-find-your-suitcase{
            display: none
          }

          #svg-deliver-your-order{
            display: none
          }

          #title-deliver-your-order{
            display: flex;
            justify-content: center; 
            align-items: center;
          }

          #svg-track-your-order{
            display: none
          }

          #svg-confirm-receipt{
            display: none
          }

          #svg-end-line{
            display: none
          }

          .stores {
            position: relative;
            top: 380px;
            justify-content: center
          }

          .phone-wrap {
            top: -110px
          }

          .phone {
            margin: 0 auto;
            
            
            }

        }

        @media (max-width: 935px) {
          :root {
            --page-width: 100%;
            --hero-title-size: 42px;
            --app-title-size: 30px;
            --section-title-size: 24px;
            --hero-text-size: 16px;
            --app-text-size: 16px;
          }
            
          .hero {
            padding-top: 12px;
          }

          .hero h1 {
            max-width: 100%;
            font-size: 35px
          }

          .hero p {
            max-width: none;
            font-size: 20px;
            margin: 10px 0 10px
          }

          .features {
            grid-template-columns: 1fr;
          }

          .feature h2 { 
            font-size: 18px
          }

          .feature p {
            font-size: 14px
          }

          .steps-grid{
            grid-template-columns: 1fr;
          }

          .band {
            font-size: 15px;
          }

          #how-it-works { 
            margin-top: -15px
          }

          .step label {
            font-size: 16px
          }

          .step small {
            font-size: 16px;
            text-align: center
          }
          
          .app-copy h2 {
            max-width: none;
          }

          .phone-wrap {
            min-height: 240px;
          }

          .pricing-wrap {
            padding: 24px 0 28px;
            overflow: hidden;
        }

        .pricing-grid {
            display: flex;
            gap: 14px;
            overflow-x: auto;
            padding: 0 16px 8px;
            scroll-snap-type: x mandatory;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
        }

        .pricing-grid::-webkit-scrollbar {
            display: none;
        } 

        .price-card {
            flex: 0 0 82%;
            scroll-snap-align: start;
            min-height: 220px;
        }

        .app-section {
            display: block
        }

        }

        @media (max-width: 404px) {
          .phone-wrap {
            top: -100px
          }

          .stores {
            display: flex;
            flex-wrap: nowrap;
          }

          .store {
            min-width: 40%
          }

          .store div {
            font-size: 65%
          }
        }

        @media (max-width: 430px) {
         .app-section {
            width: 90%;
         }

         .container-title-app-section {
            width: 90% 
          } 

          .stores {
            width: 100%;
            gap: 14px;
            justify-content: center;
            }
        }
      `}</style>

      <main style={{ overflow: "hidden" }}>
        <section className="page hero">
          <div className="hero-copy">
            <h1>O envio de encomendas de longa distância evoluiu!</h1>
            <p className="subtitle-main">
              Ganhe dinheiro extra levando encomendas ao viajar.
            </p>
            <div className="cta" onClick={handleStorage}>
              <span style={{ marginTop: -2 }}>Ofereça sua mala</span>
            </div>
          </div>

          <div className="hero-visual">
            <div className="circle-photo">
              <img
                alt="Homem em aeroporto"
                loading="eager"
                fetchpriority="high"
                src={imgMain}
              />
            </div>
          </div>
        </section>

        <section className="page container-search-bar" aria-label="busca">
          <Search />

          <div className="features">
            <article className="feature">
              <h2>Simples e econômico</h2>
              <p className="feature-step-1">
                Nada de alfândegas no meio do caminho atrasando a chegada e nem
                impostos e taxas-surpresa em suas encomendas.
              </p>
            </article>
            <article className="feature">
              <h2>Inteligente e seguro</h2>
              <p className="feature-step-2">
                Milhares de viajantes e de destinos todos os dias. Seja de moto,
                carro, trem, ônibus ou avião, alguém levará oque precisa.
              </p>
            </article>
            <article className="feature">
              <h2>Sem burocracia</h2>
              <p className="feature-step-3">
                O valor da sua encomenda esta assegurado em casos raros de
                extravio ou danificações e o recebimento do valor em até 72h.
              </p>
            </article>
          </div>
        </section>

        <div className="band" style={{ marginTop: "40px" }}>
          ENVIE SUA ENCOMENDA DE FORMA SIMPLES E SEM IMPREVISTOS
        </div>

        <section id="how-it-works" className="page steps">
          <div className="steps-grid">
            <svg
              className="svg-lines"
              viewBox="0 0 310 290"
              preserveAspectRatio="xMidYMid meet"
              id="svg-find-your-suitcase"
              style={{ overflow: "visible" }}
            >
              <line
                x1="-10000000000"
                y1="220"
                x2="170"
                y2="240"
                className="path-style"
              />
              <path
                d="M 170,240 A 90,90 0 0 1 270,150 L 270,20"
                className="path-style"
              />
              <circle
                cx="270"
                cy="10"
                r="7"
                fill="none"
                stroke="#19c7c8"
                strokeWidth="4"
              />
            </svg>

            <div className="step">
              <div className="text">
                <label id="title-find-your-suitcase">Encontre sua mala</label>
                <small id="desc-find-your-suitcase">
                  Escolha o local de origem, destino, tipo de encomenda, atribua
                  um valor de seguro e veja a data mais proxima da entrega.
                </small>
              </div>
              <div className="bubble" id="bubble-find-your-suitcase">
                <img src={icone1} alt="Ícone" className="icon-bubble" />
              </div>
            </div>

            <svg
              className="svg-lines"
              viewBox="0 0 310 290"
              preserveAspectRatio="xMidYMid meet"
              id="svg-deliver-your-order"
              style={{
                overflow: "visible",
                //transform: "scaleY(-1)",
                transformOrigin: "center",
              }}
            >
              <line x1="70" y1="238" x2="170" y2="238" className="path-style" />
              <path
                d="M 170,240 A 90,90 0 0 1 270,150 L 270,20"
                className="path-style"
              />
              <circle
                cx="270"
                cy="10"
                r="7"
                fill="none"
                stroke="#19c7c8"
                strokeWidth="4"
              />
            </svg>

            <div className="step">
              <div className="text">
                <label id="title-deliver-your-order">
                  Entregue sua encomenda
                </label>
                <small id="desc-deliver-your-order">
                  Registre por foto o estado da encomenda no momento do envio
                  que sera confirmada pelo viajante ao aceitar a missao
                </small>
              </div>
              <div className="bubble" id="bubble-deliver-your-order">
                <img src={icone2} alt="Ícone" className="icon-bubble" />
              </div>
            </div>

            <svg
              className="svg-lines"
              viewBox="0 0 310 290"
              preserveAspectRatio="xMidYMid meet"
              id="svg-track-your-order"
              style={{ overflow: "visible" }}
            >
              <line x1="85" y1="240" x2="170" y2="240" className="path-style" />
              <path
                d="M 170,240 A 90,90 0 0 1 270,150 L 270,20"
                className="path-style"
              />
              <circle
                cx="270"
                cy="10"
                r="7"
                fill="none"
                stroke="#19c7c8"
                strokeWidth="4"
              />
            </svg>

            <div className="step">
              <div className="text">
                <label id="title-track-your-order">
                  Acompanhe sua encomenda
                </label>
                <small id="desc-track-your-order">
                  Viaja pelo aplicativo onde esta o viajante e sua encomenda em
                  tempo real ate a chegada ao destino indicado.
                </small>
              </div>
              <div className="bubble" id="bubble-track-your-order">
                <img src={icone3} alt="Ícone" className="icon-bubble" />
              </div>
            </div>

            <svg
              className="svg-lines"
              viewBox="0 0 310 290"
              preserveAspectRatio="xMidYMid meet"
              id="svg-confirm-receipt"
              style={{
                overflow: "visible",
                transform: "scaleY(-1)",
                transformOrigin: "center",
              }}
            >
              <line x1="70" y1="239" x2="170" y2="239" className="path-style" />
              <path
                d="M 170,240 A 90,90 0 0 1 270,150 L 270,20"
                className="path-style"
              />
              <circle
                cx="270"
                cy="10"
                r="7"
                fill="none"
                stroke="#19c7c8"
                strokeWidth="4"
              />
            </svg>

            <div className="step">
              <div className="text">
                <label id="title-confirm-receipt">Confirme o recebimento</label>
                <small id="desc-confirm-receipt">
                  A encomenda sera entregue para a pessoa indicada que ira ver e
                  comparar a encomenda com a foto inicial.
                </small>
              </div>
              <div className="bubble" id="bubble-confirm-receipt">
                <img src={icone4} alt="Ícone" className="icon-bubble" />
              </div>
            </div>

            <svg
              className="svg-lines"
              viewBox="0 0 310 290"
              preserveAspectRatio="xMidYMid meet"
              id="svg-end-line"
              style={{
                overflow: "visible",
                transform: "scaleY(-1)",
                transformOrigin: "center",
              }}
            >
              <line
                x1="0"
                y1="235"
                x2="100000"
                y2="235"
                className="path-style"
              />
            </svg>
          </div>
        </section>

        <section
          id="prices"
          className="pricing-wrap"
          style={{ "--bg-image": `url(${mapaPontilhado})` }}
        >
          <div className="page">
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={mobile}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              slidesPerView={1}
              centeredSlides={true}
              spaceBetween={10}
              breakpoints={{
                480: {
                  slidesPerView: 1.2,
                  spaceBetween: 15,
                },
                721: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                  centeredSlides: false,
                },
                981: {
                  slidesPerView: 4,
                  spaceBetween: 24,
                  centeredSlides: false,
                },
              }}
            >
              <SwiperSlide>
                <article className="price-card">
                  <h2 className="title-badge">Documentos</h2>

                  <div className="price-badge">
                    <span className="currency-badge">R$</span>
                    <span className="value-badge">160</span>
                    <span className="cents-badge">,00</span>
                  </div>

                  <div className="route-container">
                    <div className="location-badge">São Paulo - SP</div>
                    <div className="icon-box">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#1cb5e0"
                        strokeWidth="3"
                      >
                        <path d="M7 7l10 10M17 7v10H7" />
                      </svg>
                    </div>
                    <div className="location-badge">Lisboa - PT</div>
                  </div>

                  <div className="footer-badge">
                    <span className="material-icons clock-icon-badge">
                      schedule
                    </span>
                    <span className="duracao-badge">Duração: 2 dias</span>
                  </div>
                </article>
              </SwiperSlide>

              <SwiperSlide>
                <article className="price-card">
                  <h2 className="title-badge">Mala pequena</h2>

                  <div className="price-badge">
                    <span className="currency-badge">R$</span>
                    <span className="value-badge">150</span>
                    <span className="cents-badge">,00</span>
                  </div>

                  <div className="route-container">
                    <div className="location-badge">Rio de Janeiro - RJ</div>
                    <div className="icon-box">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#1cb5e0"
                        strokeWidth="3"
                      >
                        <path d="M7 7l10 10M17 7v10H7" />
                      </svg>
                    </div>
                    <div className="location-badge">Campinas - SP</div>
                  </div>

                  <div className="footer-badge">
                    <span className="material-icons clock-icon-badge">
                      schedule
                    </span>
                    <span className="duracao-badge">Duração: 1 dia</span>
                  </div>
                </article>
              </SwiperSlide>

              <SwiperSlide>
                <article className="price-card">
                  <h2 className="title-badge">Mala de 23kg</h2>

                  <div className="price-badge">
                    <span className="currency-badge">R$</span>
                    <span className="value-badge">330</span>
                    <span className="cents-badge">,00</span>
                  </div>

                  <div className="route-container">
                    <div className="location-badge">Belo Horizonte - BH</div>
                    <div className="icon-box">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#1cb5e0"
                        strokeWidth="3"
                      >
                        <path d="M7 7l10 10M17 7v10H7" />
                      </svg>
                    </div>
                    <div className="location-badge">Londres - UK</div>
                  </div>

                  <div className="footer-badge">
                    <span className="material-icons clock-icon-badge">
                      schedule
                    </span>
                    <span className="duracao-badge">Duração: 2 dias</span>
                  </div>
                </article>
              </SwiperSlide>

              <SwiperSlide>
                <article className="price-card">
                  <h2 className="title-badge">Documentos</h2>

                  <div className="price-badge">
                    <span className="currency-badge">R$</span>
                    <span className="value-badge">160</span>
                    <span className="cents-badge">,00</span>
                  </div>

                  <div className="route-container">
                    <div className="location-badge">São Paulo - SP</div>
                    <div className="icon-box">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#1cb5e0"
                        strokeWidth="3"
                      >
                        <path d="M7 7l10 10M17 7v10H7" />
                      </svg>
                    </div>
                    <div className="location-badge">Lisboa - PT</div>
                  </div>

                  <div className="footer-badge">
                    <span className="material-icons clock-icon-badge">
                      schedule
                    </span>
                    <span className="duracao-badge">Duração: 2 dias</span>
                  </div>
                </article>
              </SwiperSlide>
            </Swiper>
          </div>
        </section>

        <section className="page app-section">
          <div className="app-copy">
            <h2 className="container-title-app-section">
              <span className="accent">Baixe o app</span> e acompanhe a sua
              encomenda em tempo real!
            </h2>
            <p>Fácil, rápido e seguro.</p>
            <div className="stores">
              <a className="store" href="#" onClick={handlePrevent}>
                <span>
                  <img
                    src="https://www.freepnglogos.com/uploads/google-play-png-logo/world-google-play-png-logo-4.png"
                    style={{ width: 30, marginTop: 10 }}
                  />
                </span>
                <div>
                  <em>Baixar na</em>Google Play
                </div>
              </a>
              <a className="store" href="#" onClick={handlePrevent}>
                <span>
                  <img
                    src="https://www.freepnglogos.com/uploads/apple-logo-png/carve-apple-logo-pumpkin-5.png"
                    style={{ width: 30, marginTop: 10 }}
                  />
                </span>
                <div>
                  <em>Disponível na</em>App Store
                </div>
              </a>
            </div>
          </div>

          <div className="phone-wrap">
            <div
              className="phone"
              style={{ "--bg-image": `url(${logoHeader})` }}
            >
              <div className="shadow-phone"></div>
              <div className="shadow-phone-2"></div>
            </div>
          </div>
        </section>

        <section className="benefit-section">
          <h2 className="section-title">
            Ofereça espaço na mala e ganhe dinheiro extra.
          </h2>

          <Swiper
            modules={[Autoplay]}
            slidesPerView={1.2}
            centeredSlides={true}
            spaceBetween={0}
            loop={true}
            speed={800}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              768: { slidesPerView: 2.2 },
              1024: { slidesPerView: 3.5 },
            }}
          >
            {[...slides, ...slides].map((slide, index) => (
              <SwiperSlide key={index}>
                <article className="benefit-card">
                  <img src={slide.img} alt={slide.title} loading="lazy" />

                  <div className="overlay"></div>

                  {/* Número por cima */}
                  <div className="slide-number">{slide.num}</div>

                  <div className="txt">
                    <h3>{slide.title}</h3>
                    <p style={{ fontSize: 16 }}>{slide.text}</p>
                  </div>
                </article>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </main>
      <Footer />
    </>
  );
}
